// extracted by mini-css-extract-plugin
export default {"large":"FileIcon_large__5jlpC","medium":"FileIcon_medium__oWjDs","normal":"FileIcon_normal__f-lS2","small":"FileIcon_small__Ow6Gy"};